import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import type { ReusablePreviewStoryblok } from "@/generated/sb/sb-types";

export const ReusablePreviewBlok = ({
  blok,
  preview,
}: BlokProps<ReusablePreviewStoryblok>) => {
  return (
    <BlokWrap editable={blok} as="section">
      {blok.body && (
        <StoryblokComponentList bloks={blok.body} preview={preview} />
      )}
    </BlokWrap>
  );
};
